module.exports = __webpack_public_path__ + "./docs/img/icon-portuguese.70ff06ae816c4d0112e2722b3ac3890a.svg";